import { useEffect } from "react";
import { useAppSelector } from "../../../Store";
import { UndefinedOptions } from "..";
import { ValueType } from "../../../Definitions";
import { gql, useQuery } from "@apollo/client";
import { selectAllGroupOptions, upsertGroupOptions } from "../../../Store/optionsHandlers/optionsCombinedReducer";
import { BasicQueryInfoInput } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";
import { useDispatch } from "react-redux";

export const ANIMAL_GROUP_OPTIONS = gql`
  query AnimalGroupOptions($domain: String!, $input: BasicQueryInfoInput!) {
    animalGroup {
      animalGroup(domain: $domain, input: $input) {
        label: name
        id: animal_group_id
      }
    }
  }
`

interface AnimalGroupOptionsResult {
  animalGroup: {
    animalGroup: ValueType[];
  }
}

export const useGroupOptions = (includeUndefinedOption?: UndefinedOptions) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";

  const fetchTime = useAppSelector(({optionsState}) => {if ("lastFetched" in optionsState.groupOptions && typeof optionsState.groupOptions.lastFetched === "number") {return optionsState.groupOptions.lastFetched}})
  const dispatch = useDispatch();
  const reduxOptions = useAppSelector(selectAllGroupOptions);
  const {data, loading} = useQuery<AnimalGroupOptionsResult, {domain: string, input: BasicQueryInfoInput}>(ANIMAL_GROUP_OPTIONS, {
   skip: !!reduxOptions.length || fetchTime !== undefined || (fetchTime && (Date.now()-fetchTime > 300000)),
    fetchPolicy: "no-cache",
    variables: {
      domain: farm,
      input: {fetchAmount: 500}
    }
  })

  useEffect(() => {
    if (!loading && data && !reduxOptions.length) {
      dispatch(upsertGroupOptions(data.animalGroup.animalGroup))
    }
  },[data, dispatch, loading, reduxOptions.length])


  let undefinedOption = null;
  if (includeUndefinedOption) {
    undefinedOption = includeUndefinedOption === "NaN" ?  { label: "no group", id: NaN } : { label: "no group", id: null}
  }
  // NOTE the cast is because we fuck about with nullish ids
  return undefinedOption ? [undefinedOption, ...reduxOptions] as ValueType[]: reduxOptions;
};
